import { useTranslation } from 'react-i18next';
import { Moon, Sun } from 'lucide-react';

import { setThemePreference, useResolvedTheme } from '../../utils/theme';
import { trackEvent } from '../../utils/gt';

// One tap between light and dark (Conta › Aparência also offers Automático)
export const ThemeToggle = ({ className = '', withLabel = false }) => {
  const { t } = useTranslation();
  const theme = useResolvedTheme();
  const next = theme === 'dark' ? 'light' : 'dark';
  const label = t(next === 'dark' ? 'components.ThemeToggle.toDark' : 'components.ThemeToggle.toLight');
  const Icon = next === 'dark' ? Moon : Sun;

  return (
    <button
      type="button"
      className={`mt-theme-toggle ${className}`.trim()}
      onClick={() => {
        trackEvent(`theme_toggle_${next}`, `Theme Toggle - ${next}`, 'theme', true);
        setThemePreference(next);
      }}
      aria-label={withLabel ? undefined : label}
      title={label}
    >
      <Icon aria-hidden="true" />
      {withLabel && <span>{label}</span>}
    </button>
  );
};
